import { Spinner } from 'components/shared/Spinner';

export const AuthGateSkeleton = () => {
  return (
    <section className="flex min-h-screen w-full flex-col items-center justify-center gap-4">
      <Spinner />

      <p className="text-sm text-black opacity-50 dark:text-white">
        Authenticating...
      </p>
    </section>
  );
};
